import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import GlobalSourcing from "@/pages/GlobalSourcing";
import Categories from "@/pages/Categories";
import Markets from "@/pages/Markets";
import Procurement from "@/pages/Procurement";
import Suppliers from "@/pages/Suppliers";
import Partner from "@/pages/Partner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <div className="bg-[#FBF9F6] min-h-screen">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/sourcing" element={<GlobalSourcing />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/markets" element={<Markets />} />
              <Route path="/procurement" element={<Procurement />} />
              <Route path="/suppliers" element={<Suppliers />} />
              <Route path="/partner" element={<Partner />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
